import { render, staticRenderFns } from "./SystemItem.vue?vue&type=template&id=80c0c480&scoped=true"
import script from "./SystemItem.vue?vue&type=script&lang=js"
export * from "./SystemItem.vue?vue&type=script&lang=js"
import style0 from "./SystemItem.vue?vue&type=style&index=0&id=80c0c480&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c0c480",
  null
  
)

export default component.exports